import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-sign-out-circle fw-bold me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    class: "nav-link fw-bold",
    "aria-label": _ctx.$t('Cerrar sesión'),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
  }, [
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('Cerrar sesión')), 1)
  ], 8, _hoisted_1))
}